import { useEffect, useState } from "react";
import { isEmpty, groupBy } from "lodash";
import { MdPermPhoneMsg, MdPlayCircleFilled } from "react-icons/md";
import { BiError } from "react-icons/bi";
import { IoIosArrowDropdown, IoIosTrash } from "react-icons/io";
import { useContext } from "react";
import { Accordion, Card, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import VideoContext from "../../store/video-context";
import { toast } from "react-toastify";
import AdPopup from "../AdPopup/AdPopup";
import cartIcon from "../../assets/Icon-awesome-cart-plus.svg"
import expertIcon from "../../assets/noun-question-3407992.svg"

var timeout: any;
const Lapaccordion = (props: any) => {
  const vContext = useContext(VideoContext);
  const myObj: { [index: string]: any } = {};
  const [accordionGroup, setAccordionGroup] = useState(myObj);
  // const isAdmin = props.isAdmin;

let accordionMetadata : any = [];

if(props.data.txData[0].transmission_ppt_id == "1"){

  accordionMetadata = [
      { accordionHeader: "Instruments on trolley", keyvalue: "equipment" },
   { accordionHeader: "Topics", keyvalue: "topic" },
  ];

}else{
  accordionMetadata = [

    { accordionHeader: "Instruments on trolley", keyvalue: "equipment" },
    { accordionHeader: "Steps Tagged", keyvalue: "indexstep" },
 //   { accordionHeader: "Topics", keyvalue: "topic" },
   { accordionHeader: "Anatomy Tagged", keyvalue: "anatomy" },

  ];


}


  useEffect(() => {
    let groupByObject = groupBy(vContext.accordionData, "flag");
    accordionMetadata.map((item: any) => {
      item["data"] = groupByObject[item.keyvalue]
        ? groupByObject[item.keyvalue]
        : [];
    });
    setAccordionGroup(accordionMetadata);
  }, [vContext.accordionData]);

  const convertSecondToHH_MM_SS = (seconds: any) => {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
  };

  const handlerDeleteTag = (id: any, flag: any) => {
 
      fetch(
        "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=deleteTag&transID=" +
          vContext.transId +
          "&taggedID=" +
          id +
          "&flag=" +
          flag
      )
        .then((res) => res.json())
        .then((deleteIndexstepTagData) => {
          // console.log("deleteIndexstepTagData", deleteIndexstepTagData);
          if (deleteIndexstepTagData.status === "success") {
            vContext.deleteAccordionDataHandler(id);
            let notificationMsg = "Tagged Item Deleted Successfully!";
            toast.dark(notificationMsg, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            // console.log("fail delete anatomy")
            toast.dark("Delete Tagged Item Failed!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          console.error("Error:(handlerDeleteIndexstepTag)", error);
        });

      
  
  
  };

  const handlerDeleteAccordionItem = (e: any, item: any) => {
    // console.log('item',item);
    // console.log('e',e)
    e.stopPropagation();
    handlerDeleteTag(item.id, item.flag);
    // switch (item.flag) {
    //   case 'step':
    //     handlerDeleteTag(item.id,item.flag);
    //     break;
    //   case 'anatomy':
    //     handlerDeleteTag(item.id,item.flag);
    //     break;
    //   case 'equipment':
    //     handlerDeleteTag(item.id,item.flag);

    //     break;
    //   default:
    //     break;
    // }
  };
  const handlerEnquiryAccordionItem = (e: any, item: any) => {
    // console.log('item',item);
    // console.log('e',e);
    e.stopPropagation();
    // if (item.equipment_link !== undefined && item.equipment_link !== "") {
    //   window.open("" + item.equipment_link, "_blank");
    // }
    let taggedID = item.id !== undefined ? item.id : "0";
    fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveEquipmentEnquiry&transID="+vContext.transId+"&equipmentID="+item.equipment_id+"&taggedID="+taggedID+"&userID="+vContext.userId+"&confirm=0")
    .then(res=>res.json())
    .then((instrumentEnquirey)=>{
      // console.log("instrumentEnquirey", instrumentEnquirey);
      if(instrumentEnquirey.status === "success"){
        // vContext.deleteAccordionDataHandler(id);
        // toast.dark("Intrument Enquiry Successfully Captured!", {
        //   position: "top-center",
        //   autoClose: 5000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   });
        // console.log('enquiry details successfully captured');
      }else{
        // console.log("fail delete anatomy");
        toast.dark("Intrument Enquiry Failed!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    })
    .catch((error)=>{
      console.error('Error:(handlerEnquiryAccordionItem)', error);
    })
  };
  const getUserAgent = () => {
    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return (
          navigator.userAgent.match(/IEMobile/i) ||
          navigator.userAgent.match(/WPDesktop/i)
        );
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    if (isMobile.any()) {
      return "mobile";
    } else {
      return "pc";
    }
  };

  const [show, setShow] = useState(false);

  const openAdModal = (e: any, item: any) => {
    setShow(true);
    vContext.setIsInstrumentEnquiryHandler(true);
    vContext.setInstrumentEnquiryHandler(item);
    handlerEnquiryAccordionItem(e,item);
  };

  const closeAdModal = () => {
    setShow(false);
  };

  return (
    <>

      <Accordion
        defaultActiveKey={getUserAgent() === "pc" ? "equipment" : ""}
        className="blue-shadow-box"
      >
        {!isEmpty(accordionGroup) &&
          accordionGroup.map((group: any, key: any) => (
            <Card>
              <Accordion.Collapse
                eventKey={group.keyvalue}
                className="card-body"
              >
                <>
                  <div className="tagged-links-list">
                    {group.data.length > 0 &&
                      group.data.map((item: any) => (
                        <>
                          {group.keyvalue === "equipment" && (
                            <div className="tagged-link-item" key={item.id}>
                              <div
                                className="tagged-link-text cursor-pointer"
                                onClick={() => props.seekVideo(item.time)}
                              >
                                <div
                                  className="tagged-link-text-title"
                                  title={item.name}
                                >
                                  {item.name}
                                </div>
                                <div className="tagged-link-text-time">
                                  <MdPlayCircleFilled size={14} />{" "}
                                  {convertSecondToHH_MM_SS(item.time)}
                                </div>
                              </div>
                              {
                                // (isAdmin)?
                                vContext.userRole !== "viewer" ? (
                                  <div
                                    className="tagged-link-icon"
                                    onClick={(e) => {
                                      handlerDeleteAccordionItem(e, item);
                                    }}
                                  >
                                    <IoIosTrash size={22} />
                                  </div>
                                ) : (
                                  <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={
                                    <Popover id="tooltip-helper1" className="tooltip-helper video-bookmark-tooltip">                                      
                                      <Popover.Content>{item.hospital_buy_product !== "" ? "Speak to our experts for more information on this product" : "Buy this item on our marketplace"}</Popover.Content>
                                    </Popover>}>
                                  <div
                                    className="tagged-link-icon"
                                    onClick={(e) => {
                                      // handlerEnquiryAccordionItem(e, item);
                                      openAdModal(e, item)
                                    }}
                                  >
                                    {/* <MdPermPhoneMsg size={22} /> */}
                                    
                                      {/* <MdPermPhoneMsg size={22} /> */}
                                      {item.hospital_buy_product !== "" ? 
                              
                                      <img src={expertIcon} alt="" />
                                      : 
                                      <img src={cartIcon} alt="" />}
                                  </div>
                                  </OverlayTrigger>
                                )
                              }
                            </div>
                          )}
                          {group.keyvalue !== "equipment" && (
                            <div className="tagged-link-item" key={item.id}>
                              <div
                                className="tagged-link-text cursor-pointer"
                                onClick={() => {
                                  props.seekVideo(item.time); 
                                  vContext.setAccordionClickedItemHandler(item);
                                  clearTimeout(timeout);
                                  timeout = setTimeout(()=>{
                                    vContext.setAccordionClickedItemHandler({});
                                  }, 5000)
                                }}
                              >
                                <div
                                  className="tagged-link-text-title"
                                  title={item.name}
                                >
                                  {item.name}
                                </div>
                                <div className="tagged-link-text-time">
                                  <MdPlayCircleFilled size={14} />{" "}
                                  {convertSecondToHH_MM_SS(item.time)}
                                </div>
                              </div>
                              {
                                // (isAdmin)?
                                vContext.userRole === "admin" ||
                                vContext.userRole === "moderator" ? (
                                  <div
                                    className="tagged-link-icon"
                                    onClick={(e) => {
                                      handlerDeleteAccordionItem(e, item);
                                    }}
                                  >
                                    <IoIosTrash size={22} />
                                  </div>
                                ) : (
                                  <></>
                                )
                              }
                            </div>
                          )}
                        </>
                      ))}
                    {group.keyvalue === "equipment" &&
                      vContext.equipmentList.map((item: any) => (
                        <>
                          {group.keyvalue === "equipment" && (
                            <div
                              className="tagged-link-item"
                              key={item.equipment_id}
                            >
                              <div className="tagged-link-text">
                                <div
                                  className="tagged-link-text-title"
                                  title={item.equipment_name}
                                >
                                  {item.equipment_name}
                                </div>
                                {/* <div className="tagged-link-text-time"><MdPlayCircleFilled size={14} /></div> */}
                              </div>
                              <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={
                                    <Popover id="tooltip-helper1" className="tooltip-helper video-bookmark-tooltip">                                      
                                      <Popover.Content>{item.hospital_buy_product == "" ? "Speak to our experts for more information on this product" : "Buy this item on our marketplace"}</Popover.Content>
                                    </Popover>}>
                              <div
                                className="tagged-link-icon"
                                onClick={(e) => {
                                  // handlerEnquiryAccordionItem(e, item);
                                  openAdModal(e, item)
                                }}
                              >
                                {/* <MdPermPhoneMsg size={22} /> */}
                               
                                      {/* <MdPermPhoneMsg size={22} /> */}
                                      {item.hospital_buy_product == "" ? <img src={expertIcon} alt="" />: <img src={cartIcon} alt="" />}
                              </div>
                                  </OverlayTrigger>
                            </div>
                          )}
                        </>
                      ))}
                    {group.keyvalue === "equipment" &&
                      group.data.length === 0 &&
                      vContext.equipmentList.length === 0 && (
                        <div className="tagged-link-notfound">
                          <BiError size={22} /> No tagged record found
                        </div>
                      )}
                    {group.keyvalue !== "equipment" && group.data.length === 0 && (
                      <div className="tagged-link-notfound">
                        <BiError size={22} /> No tagged record found
                      </div>
                    )}
                  </div>
                </>
              </Accordion.Collapse>
              <Accordion.Toggle as={Card.Header} eventKey={group.keyvalue}>
                <span>{group.accordionHeader}</span>
                <IoIosArrowDropdown size={22} />
              </Accordion.Toggle>
            </Card>
          ))}
      </Accordion>
      <Modal show={show} onHide={closeAdModal}>
        <AdPopup oncloseEvent={closeAdModal} timePlaceholder={"What is a good time to call you?"} timePlaceholderError={"Please provide a valid time."} />
      </Modal>
    </>
  );
};
// const ContextAwareToggle = ( props: any ) => {
//   const children = props.children;
//   const eventKey = props.eventKey;
//   const callback = props.callback;
//   const currentEventKey = useContext(AccordionContext);
//   const decoratedOnClick = useAccordionToggle(
//     eventKey,
//     () => callback && callback(eventKey),
//   );
//   const isCurrentEventKey = currentEventKey === eventKey;
//   return (
//     <button
//       type="button"
//       style={{ backgroundColor: isCurrentEventKey ? 'pink' : 'lavender' }}
//       onClick={decoratedOnClick}
//     >
//       {children}
//     </button>
//   );
// }
export default Lapaccordion;
